module.exports = __webpack_public_path__ + "img/Weapon_117.52ebfd37.png";